import SiteTagsFilter from "../../components/filters/SiteTagsFilter/SiteTagsFilter";
import SiteTagsFilterResult from "../../components/filters/SiteTagsFilter/SiteTagsFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { defineLeadsFilter } from "../defineLeadsFilter";

import SiteTagsFilterModel from "./SiteTagsFilterModel";

// Options are fetched inside the view (search-as-you-type), so the filter needs no data source: it builds
// immediately. A saved search / URL value reaches it through redux (page-root init, `useApplyInitialFilters`), not as a model
// default, so the model carries no `initialDtoValue` and Clear resets it to empty.
export const siteTagsDefinition = defineLeadsFilter({
    key: "siteTags",
    apiCategory: leadsFilterApiCategory.siteTags,
    category: leadsFilterCategoryMap.company,
    trackingName: "Products and services",
    titleKey: { key: leadsSearchFiltersI18nKeys.siteTagsTitle() },

    render: () => ({
        tooltipText: { key: leadsSearchFiltersI18nKeys.siteTagsTooltip() },
        filter: new SiteTagsFilterModel({ options: undefined }),
        filterView: SiteTagsFilter,
        filterResultView: SiteTagsFilterResult,
    }),
});
